/** In-search UI: circling ring + live attempt count (see docs/design/new_auto_generator.html). */

import { useTranslation } from 'react-i18next';

function ScrollingColumn({
  nums,
  durationSec,
  reverse,
}: {
  nums: string[];
  durationSec: number;
  reverse?: boolean;
}) {
  return (
    <div
      className="auto-search-hud__col"
      style={{
        animationDuration: `${durationSec}s`,
        ...(reverse ? { animationDirection: 'reverse' as const } : {}),
      }}
    >
      {nums.map((n) => (
        <span key={`${n}-a`}>{n}</span>
      ))}
      {nums.map((n) => (
        <span key={`${n}-b`}>{n}</span>
      ))}
    </div>
  );
}

export function AutoSearchHud({ attemptCount, onStop }: { attemptCount: number; onStop: () => void }) {
  const { t } = useTranslation();
  const title = t('autoHud.title', { count: attemptCount.toLocaleString() });

  return (
    <div className="auto-search-hud" role="status" aria-live="polite" aria-atomic="true">
      <div className="auto-search-hud__bg" aria-hidden="true">
        <div className="auto-search-hud__bg-grid">
          <ScrollingColumn nums={['08', '24', '45', '12', '33', '56', '01', '19', '42', '37']} durationSec={0.4} />
          <ScrollingColumn nums={['55', '12', '04', '29', '67', '11', '38', '49', '02', '18']} durationSec={0.3} reverse />
          <ScrollingColumn nums={['13', '33', '21', '05', '09', '44', '70', '22', '16', '31']} durationSec={0.5} />
          <div className="auto-search-hud__col-wrap--md">
            <ScrollingColumn nums={['02', '07', '19', '28', '35', '41', '55', '62', '01', '09']} durationSec={0.45} reverse />
          </div>
          <div className="auto-search-hud__col-wrap--md">
            <ScrollingColumn nums={['66', '24', '12', '03', '18', '49', '33', '05', '22', '11']} durationSec={0.35} />
          </div>
        </div>
      </div>

      <div className="auto-search-hud__main">
        <div className="auto-search-hud__dial">
          <div className="auto-search-hud__dial-glass" />
          <div className="auto-search-hud__dial-spin" />
          <div className="auto-search-hud__dial-inner">
            <span className="auto-search-hud__count">{attemptCount.toLocaleString()}</span>
            <span className="auto-search-hud__unit">{t('autoHud.unit')}</span>
          </div>
        </div>

        <div className="auto-search-hud__msg">
          <div className="auto-search-hud__title-row">
            <span className="auto-search-hud__dot" aria-hidden="true" />
            <h2 className="auto-search-hud__title">{title}</h2>
          </div>
          <p className="auto-search-hud__sub">{t('autoHud.sub')}</p>
        </div>

        <button type="button" className="auto-search-hud__stop" onClick={onStop}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
            <circle cx="12" cy="12" r="10" />
            <rect x="8" y="8" width="8" height="8" rx="1" fill="currentColor" stroke="none" />
          </svg>
          {t('autoHud.stop')}
        </button>
      </div>
    </div>
  );
}
